import {Component} from '@angular/core';
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {GeolocationService} from "../../lib/services/geolocation/geolocation.service";

@Component({
    selector: 'app-geolocation-modal',
    templateUrl: './geolocation-modal.component.html',
    styleUrls: ['./geolocation-modal.component.scss']
})
export class GeolocationModalComponent {


    constructor(private geolocationService: GeolocationService) {
    }

    closeGeolocationModal() {
        this.geolocationService.closeGeolocationModal()
    }
}
